module.exports = __webpack_public_path__ + "img/why-ico2.c43c64a1.png";